export const RESETING_PASSWORD = "RESETING_PASSWORD";
export const RESETING_PASSWORD_FINISHED = "RESETING_PASSWORD_FINISHED";

export const resetingPassword = () => ({ type: RESETING_PASSWORD });
export const resetingPasswordFinished = () => ({
  type: RESETING_PASSWORD_FINISHED,
});
